import React from 'react';
import { Alert, Text, Textarea, Checkbox, Stack, Grid } from '@good/ui/core';
import { DatePickerInput } from '@good/ui/dates';
import moment from 'moment-timezone';
import { Door } from '@good/illustrations';
import { TeamMember } from 'interfaces/team-member-interface';

type IPermanentlyRemoveUserModalStep1 = {
  worker: TeamMember;
  isSelectFutureDate: boolean;
  removalDate: Date | null;
  removeReason: string | undefined;
  onCheckBoxChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onChangeRemovalDate: (date: Date | null) => void;
  onChangeRemoveReason?: (reason: string) => void;
};

export const PermanentlyRemoveUserModalStep1 = ({
  worker,
  isSelectFutureDate,
  removalDate,
  removeReason,
  onCheckBoxChange,
  onChangeRemovalDate,
  onChangeRemoveReason,
}: IPermanentlyRemoveUserModalStep1) => {
  return (
    <Stack gap='md'>
      <Alert color='red' radius='lg' variant='filled'>
        This user will be removed from all upcoming shifts, sessions, and rosters that they have been assigned to. All
        private notes will be made visible to the primary owner.
      </Alert>

      <Grid>
        <Grid.Col span={3}>
          <Door />
        </Grid.Col>
        <Grid.Col span={9}>
          <Stack gap='md'>
            <Text size='sm'>
              All historical data related to this user will be maintained. This account can be reinstated at a later
              date.
            </Text>

            {!worker.removedOn && (
              <Checkbox
                checked={isSelectFutureDate}
                onChange={onCheckBoxChange}
                label='I want to remove this user at a future date'
                radius='xs'
                size='sm'
              />
            )}

            {isSelectFutureDate && (
              <DatePickerInput
                label='Removal Date'
                placeholder='Select removal date'
                value={removalDate}
                onChange={onChangeRemovalDate}
                minDate={new Date(moment().add(1, 'days').format('YYYY/MM/DD'))}
              />
            )}
          </Stack>
        </Grid.Col>
      </Grid>

      <Textarea
        label='Removal Reason'
        placeholder='Enter reason for removing user...'
        value={removeReason || ''}
        onChange={(event) => onChangeRemoveReason?.(event.currentTarget.value)}
        minRows={2}
        required
        error={
          removeReason && removeReason.length > 0 && removeReason.length < 5
            ? 'Please enter at least 5 characters'
            : undefined
        }
      />
    </Stack>
  );
};
